<template>
    <div class="fill-height of-y">
        <v-scroll-x-transition hide-on-leave>
            <app-centre-loader v-if="loading" label="Fetching Data"/>
        </v-scroll-x-transition>

        <v-scroll-x-transition hide-on-leave>
            <div v-if="!loading" class="fill-height of-y">
                <div class="fill-height d-flex align-center justify-center overline amber--text" v-if="!stats.length">
                    No Data For Given Range
                </div>
                <div v-else class="fill-height of-y">

                    <v-data-table
                            ref="table"
                            :headers="viewColumns"
                            :items="stats"
                            :search="$store.state.ref.dashboard.filterStr"
                            :items-per-page="stats.length"
                            hide-default-footer
                            fixed-header
                            class="fill-height of-y full-table"
                            @click:row="gotoEmployee($event._id)"
                            :sortBy.sync="$store.state.sortPreference.dashboard.employees.by"
                            :sort-desc.sync="$store.state.sortPreference.dashboard.employees.order"

                    >

                        <template v-slot:item.employeeName="{ item }">
                            <div class="d-flex align-center overline" style="white-space: nowrap">
                                <v-icon left small>mdi-account</v-icon>
                                {{ item.employeeName }}
                            </div>
                        </template>
                        <template v-slot:item.teamName="{ item }">
                            <v-btn
                                    small
                                    text
                                    color="primary"
                                    @click.stop="gotoTeam(item.teamId)"
                            >
                                <v-icon left>mdi-account-group</v-icon>
                                {{ item.teamName }}
                            </v-btn>
                        </template>
                        <template v-slot:item.workTime="{ item }">{{ hoursDisplay(item.workTime, true) }}</template>
                        <template v-slot:item.activeTime="{ item }">{{ hoursDisplay(item.activeTime, true) }}</template>

<!--                        <template v-slot:header.activeTime="{header}">-->
<!--                            <div class="b1" style="width: 150px">-->
<!--                                {{header.text}}123456-->
<!--                            </div>-->
<!--                        </template>-->

                        <template v-slot:item.ptt="{ item }">{{ hoursDisplay(item.ptt, true) }}</template>
                        <template v-slot:item.ptn="{ item }">{{ hoursDisplay(item.ptn, true) }}</template>
                        <template v-slot:item.pto="{ item }">{{ hoursDisplay(item.pto, true) }}</template>
                        <template v-slot:item.utt="{ item }">{{ hoursDisplay(item.utt, true) }}</template>
                        <template v-slot:item.utn="{ item }">{{ hoursDisplay(item.utn, true) }}</template>
                        <template v-slot:item.uto="{ item }">{{ hoursDisplay(item.uto, true) }}</template>
                        <template v-slot:item.ntt="{ item }">{{ hoursDisplay(item.ntt, true) }}</template>
                        <template v-slot:item.ntn="{ item }">{{ hoursDisplay(item.ntn, true) }}</template>
                        <template v-slot:item.nto="{ item }">{{ hoursDisplay(item.nto, true) }}</template>
                        <template v-slot:item.ttt="{ item }">{{ hoursDisplay(item.ttt, true) }}</template>
                        <template v-slot:item.idleTime="{ item }">{{ hoursDisplay(item.idleTime, true) }}</template>
                        <template v-slot:item.productivityTarget="{ item }">{{ percentDisplay(item.productivityTarget) }}</template>
                        <template v-slot:item.productivityNormalTarget="{ item }">{{ percentDisplay(item.productivityNormalTarget) }}</template>
                        <template v-slot:item.productivityActive="{ item }">{{ percentDisplay(item.productivityActive) }}</template>
                        <template v-slot:item.productivityWorkTime="{ item }">{{ percentDisplay(item.productivityWorkTime) }}</template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn
                                    color="primary"
                                    class="mx-2"
                                    small
                                    icon
                                    @click.stop="gotoEmployeeSettings(item._id)"
                            >
                                <v-icon>mdi-cog</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </v-scroll-x-transition>
        <app-employee-stats-select-columns-dlg
                v-if="$store.state.ref.dashboard.showColumnSelection"
                :shown.sync="$store.state.ref.dashboard.showColumnSelection"
        />

    </div>
</template>

<script>

import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import {percentDisplay, hourDisplay, exportStats} from "@/core/codeFunctions";
import AppDlg from "@/components/Shared/AppDlg";
import AppList from "@/components/Shared/AppList/AppList";
import {mapActions, mapGetters} from "vuex";
import AppEmployeeStatsSelectColumnsDlg from "@/components/Dashboard/AppEmployeeStatsSelectColumnsDlg";
import {format, isSameDay, isSameMonth, isSameYear} from "date-fns";

export default {
    components: {AppEmployeeStatsSelectColumnsDlg, AppList, AppDlg, AppCentreLoader},
    props: {
        vm: Object
    },
    data() {
        return {
            hoursDisplay: hourDisplay,
            percentDisplay: percentDisplay,
            loading: false,
            stats: [],
            headers: [
                {text: 'Name', value: 'employeeName', description: 'Employee name'},
                {text: 'Team', value: 'teamName', description: 'Team name'},
                {text: 'Active Time', value: 'activeTime', description: 'Total time active'},
                {text: 'Productive', value: 'ptt', description: 'Total time productive'},
                {text: 'Productive Normal', value: 'ptn', description: 'Time productive during working hours'},
                {text: 'Productive Overtime', value: 'pto', description: 'Time productive outside of working hours'},
                {text: 'Unproductive', value: 'utt', description: 'Total time unproductive'},
                {text: 'Unproductive Normal', value: 'utn', description: 'Time unproductive during working hours'},
                {text: 'Unproductive Overtime', value: 'uto', description: 'Time unproductive outside of working hours'},
                {text: 'Neutral', value: 'ntt', description: 'Total time neutral'},
                {text: 'Neutral Normal', value: 'ntn', description: 'Time neutral during working hours'},
                {text: 'Neutral Overtime', value: 'nto', description: 'Time neutral outside of working hours'},
                {text: 'Target', value: 'ttt', description: 'Total target duration'},
                {text: 'Idle', value: 'idleTime', description: 'Total idle duration'},
                {text: 'Productive Target %', value: 'productivityTarget', description: 'Total productivity vs total target'},
                {text: 'Productive Active %', value: 'productivityActive', description: 'Total productivity vs total active'},
                {text: 'Productive Normal Target %', value: 'productivityNormalTarget', description: 'Total productivity in working hours vs total target'},
            ],
        }
    },
    watch: {
        "$store.state.ref.dashboard.selectedRange.start": {
            immediate: true,
            handler(val) {
                this.refreshData()
            }
        },
        devicesWithAccess(val) {
            this.refreshData()
        }
    },
    mounted() {
        // this.refreshData();
    },
    methods: {
        ...mapActions(["gotoEmployee", "gotoEmployeeSettings", "gotoTeam", "updateSelections"]),

        async exportDataDetail() {
            try {
                this.vm.$refs.navBarBody.$refs.dashboardToolbar.showLoadingExport = true;
                const stats = await this.$newReq('POST', 'dashboard/getEmployeesStatsDetail', {
                    start: this.start,
                    end: this.end,
                })

                const dateTitle = (() => {
                    if (!isSameYear(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
                        return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd MMM yyyy')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
                    if (!isSameMonth(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
                        return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd MMM')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
                    if (!isSameDay(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
                        return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
                    return format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')
                })()
                exportStats(
                        `Tracklogix Employees ${dateTitle} Detail`,
                        'Employees',
                        [{text: "Date", value: "date"}, {text: "Name", value: "employeeName"}, {text: "Employee Number", value: "employeeNumber"}, ...this.$refs.table.headers.filter(h => !['employeeName', 'employeeNumber'].includes(h.value))],
                        stats,
                        this.$store.getters.labelsRef
                )
            } catch (e) {
                this.$snack.netWorkError();
            } finally {
                this.vm.$refs.navBarBody.$refs.dashboardToolbar.showLoadingExport = false;
            }
        },

        exportData() {
            const dateTitle = (() => {
                if (!isSameYear(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
                    return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd MMM yyyy')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
                if (!isSameMonth(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
                    return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd MMM')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
                if (!isSameDay(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
                    return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
                return format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')
            })()
            exportStats(
                    `Tracklogix Employees ${dateTitle}`,
                    'Employees', [{text: "Name", value: "employeeName"}, {text: "Employee Number", value: "employeeNumber"}, ...this.$refs.table.headers.filter(h => !['employeeName', 'employeeNumber'].includes(h.value))],
                    this.$refs.table.selectableItems,
                    this.$store.getters.labelsRef
            )
        },

        async refreshData() {
            try {
                this.loading = true;
                this.stats = await this.$newReq('POST', 'dashboard/getEmployeesStats', {
                    start: this.start,
                    end: this.end,
                })
            } catch (e) {
                this.$snack.netWorkError();
            } finally {
                this.loading = false
            }
        }
    },
    computed: {
        ...mapGetters(['access', 'devicesWithAccess']),
        start() {
            return this.$store.state.ref.dashboard.selectedRange.start
        },
        end() {
            return this.$store.state.ref.dashboard.selectedRange.end
        },
        viewColumns() {

            const cols = this.headers.filter(header => {
                if (!this.$store.state.ref.dashboard.employeesSelectedColumns.length)
                    return true
                return this.$store.state.ref.dashboard.employeesSelectedColumns.includes(header.value)
            })

            return this.access.setup ? cols.concat({
                text: '',
                value: 'actions',
                sortable: false,
                align: 'center',
                width: 30
            }) : cols
        }
    },
}
</script>

<style scoped>

</style>